import React, { useCallback } from "react";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BTable from 'react-bootstrap/Table';
import { HeaderList } from "../../../components/HeaderList";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { BranchService } from "../../../services/branch.service";
import { BranchModel } from "../../../models/branch.model";
import { EquipmentModel } from "../../../models/equipment.model";
import { EquipmentService } from "../../../services/equipment.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import { HeadDateModel } from "../../../models/headDate.model";
import { EventExportService } from "../../../services/eventExport.service";
import { ForeCastService } from "../../../services/forecast.service";
import storageService from "../../../services/storage.service";
import UtilService from "../../../services/util.service";
import { useTable, usePagination, useSortBy } from 'react-table';
import { faSortAlphaUp, faSortAlphaDown, faSort } from "@fortawesome/free-solid-svg-icons";
import HelperService from "../../../services/helper.service";
import { ButtonClean, ButtonSearch, ButtonExport } from "../../../components/buttons";
import Pagination, { IPag, IPagination } from "../../../components/Pagination";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GroupModel } from "../../../models/group.model";
import GroupService from "../../../services/group.service";

function Table({columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];
  
  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style: React.CSSProperties  = {
      border: 'none',
      color: '#2196F3',
      fontWeight: 700,
      textAlign: 'left',
      paddingLeft: '10px',
      width: cellInfo?.column?.width,
    };
    return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style: React.CSSProperties = {
      width: cellInfo.column.width,
      height: '100%',
      padding: 2,
      wordBreak: 'break-word', // Garante quebra de linha no texto longo
      overflow: 'hidden' // Oculta o texto que ultrapassa o limite da célula
      
    };

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <div style={{ overflowX: 'auto' }}>
      <BTable hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.filter(x => !x.columns).map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={formatCellStyleHeader(column)}
                >
                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <div style={{ display: "table-caption" }}>
                      {column.render('Header')}
                    </div>
                    {column.canSort
                      ? column.isSorted
                        ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                        : <FontAwesomeIcon icon={faSort} />
                      : null
                    }
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            const isUpdated = row.original.isUpdated;
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {

                  if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                    return <td
                      colSpan={7}
                      {...cell.getCellProps()}
                      style={{
                        background: "#fff",
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        color: '#555',
                        padding: 0,
                        opacity: isUpdated ? 1 : 0.65
                      }}
                    >
                      <div style={formatCellStyle(cell)}>
                        {msgEmpty}
                      </div>
                    </td>
                  }

                  if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                    return <></>;
                  }
                  return (
                    <td
                      {...cell.getCellProps()}
                      
                    >
                      <div style={formatCellStyle(cell)}>
                        {cell.render('Cell')}
                      </div>
                    </td>
                  )
                }
                )}
              </tr>
            )
          })}
        </tbody>
      </BTable>
    </div>
  );
}

const PickuedUpEquipment = () => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();

  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_confirmed_equipment_pickup_schedules',
    filters: {
      branch_id: [],
      code_equipment: [], 
      date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      date_end: moment().subtract(1, 'days').format('YYYY-MM-DD') 
    },
    parameters: {}
  });

  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_confirmed_equipment_pickup_schedules',
    filters: {
      branch_id: [],
      code_equipment: [],
      date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      date_end: moment().subtract(1, 'days').format('YYYY-MM-DD')
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });


  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const [branches, setBranches] = useState<BranchModel[]>();
  const [codeEquipment, setCodeEquipment] = useState<string>();
  const [group, setGroup] = useState<GroupModel[]>();
  

  const getList = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    // Forçar requestParams.datasets[0].data a ser null
    requestParams.datasets[0].data = null;

    requestParams.parameters = {
      ...requestParams.parameters
    }

    const response: any = await ForeCastService.getEquipmentSchedulePickupList(requestParams);
    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'report_confirmed_equipment_pickup_schedules' }));
      setDatasetDashboardAnalytical(d);     
    }
    else {
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
      setDataset(requestParams.datasets[0]);
      
    }

    setLoading(false);
  };

  const initialize = async () => {
    BranchService.getAllList().then((response: any) => {
      if(response.success){
        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
        if (branchList[0].data != null)
        {
          const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
          setBranches(sort);
        }
        else
        setBranches([]);
      }else{
        setBranches([]);
      }
    });

    GroupService.getAll().then((response: any) => {
      if(response.success){
        let groupList = response.result;
        const sort = groupList.sort((a, b) => a.fullName.localeCompare(b.fullName)).filter(t=>t.inconsistentForecastAnalysis === true);
        setGroup(sort);
      }else{
        setGroup([]);
      }
    });

    await getList({
      page_number:1
    })
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();
    await getList({
      page_number:1
    });
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => {

    setDataset({ 
      ...dataset, 
      filters: { 
        branch_id: [], 
        code_equipment: [], 
        date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        date_end: moment().subtract(1, 'days').format('YYYY-MM-DD') 
      } 
    });
    setDatasetDashboardAnalytical({ 
      ...datasetDashboardAnalytical, 
      filters: { 
        branch_id: [], 
        code_equipment: [], 
        date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        date_end: moment().subtract(1, 'days').format('YYYY-MM-DD') 
      }
    });
    setCodeEquipment('');
    setFlagClear(true);
  
    // Alterando as datas padrão para o DatePicker
    setStartDate(moment().subtract(7, 'days').toDate());  // Mudando de 1 mês atrás para 7 dias atrás
    setEndDate(moment().subtract(1, 'days').toDate());    // Mudando para 1 dia atrás
    setMaxDate(moment().subtract(1, 'days').toDate());    // Mudando para 1 dia atrás
  };

  const exportFile = async () => { 
    getListExport(null, 'Excel');
  };

  const getListExport = async (dataTable, type: string) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    requestParams.parameters = {
      ...requestParams.parameters, type
    }

    EventExportService.ExportPickupUpEquipmentForecast(requestParams, type).finally(() =>
      setLoading(false)
    ); 

  };

  const [maxDate, setMaxDate] = useState(moment().subtract(1, 'days').toDate());
  const calcMaxDate = (start, end) => {
    if (end)
      return moment().toDate();
    let startDate = moment(start).add(29, "day").toDate();    
    return moment().toDate() > (startDate) ? startDate : moment().toDate();
  }

  const [startDate, setStartDate] = useState(moment().subtract(7, "days").toDate());
  const [endDate, setEndDate] = useState(moment().subtract(1, 'days').toDate());
  
  const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
  const idiom = storageService.getIdiom();

  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [ , datasetDashboardAnalytical?.data, selectedDataDashboard]);


  const columns = React.useMemo(
    () => [
      {
        Header: t("INCONSISTENT.EQUIPMENT"),
        background: '#4b4b50',
        columns: [
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.REGIONAL")}</span>),
              accessor: "regional",
              background: '#999999',
              disableSortBy: true,
              width: 50, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.BRANCH")}</span>),
              accessor: "branch_nickname",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.LEGAL_NAME")}</span>),
              accessor: "legal_name",
              background: '#999999',
              disableSortBy: true,
              width: 120, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.EQUIPMENT")}</span>),
              accessor: "code_equipment",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.CONTRACTUAL_LIMIT")}</span>),
              accessor: "limit_contractual",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatToCurrency(props.value))
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.PICKUP_PERCENTAGE")}</span>),
              accessor: "ideal_pickup_percentage",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.LIMIT_PHYSICAL_PERCENTAGE")}</span>),
              accessor: "physical_limit_percentage",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.SCHEDULING_DATE")}</span>),
              accessor: "pickup_date",
              background: '#999999',
              disableSortBy: true,
              width: 150, 
              Cell: props => (formatDateTime(props.value))
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.FORECAST_VALUE_FOR_THE_SCHEDULING_DAY")}</span>),
              accessor: "forecast_value_before_pickup",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatToCurrency(props.value))
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.PICKUP_DATE_EXECUTED")}</span>),
              accessor: "realized_date",
              background: '#999999',
              disableSortBy: true,
              width: 150, 
              Cell: props => (formatDateTime(props.value))
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.PICKUP_VALUE")}</span>),
              accessor: "pickup_equipment_data",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatToCurrency(props.value))
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.PICKUP_SAFE_PERCENTAGE")}</span>),
              accessor: "collected_safe_percentage",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.PICKUP_BANKNOTES_PERCENTAGE")}</span>),
              accessor: "collected_banknotes_percentage",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.OPERATOR")}</span>),
              accessor: "operator",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },      
            {
              Header: props => (<span>{t("EQUIPMENT_SCHEDULE_PICKUP.SIGA_REQUEST_ID")}</span>),
              accessor: "siga_request_id",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },        
        ]
      },
    ],
    []
  );

  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };

  const formatDateTimeAndTime = (value) => {
    console.log("Valor recebido:", value);  // Verifica o valor recebido
    const formattedValue = UtilService.formatDateAndTime(value, user.locale.formatDateTime);
    
    // Exibe o valor formatado no console
    console.log("Valor formatado:", formattedValue);
    
    return formattedValue;
  }
  

  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    
    <>
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <HeaderList title={t(`INCONSISTENT.TITLE_PICKUP_PERCENT`)} />
      </div>
      <Form>
      <Form.Label className="mb-1">{t("FILTERS")}</Form.Label>
        <Row className="align-items-center">
          <Col xs="auto">
            <DatePicker
              onChange={(date) => {
                const [start, end] = date;
                const retstart = start ? moment(start).format('YYYY-MM-DD') : null;
                const retend = end ? moment(end).format('YYYY-MM-DD') : null;
                const dateret = [retstart, retend];
                
                setDataset({
                  ...dataset,
                  filters: { ...dataset.filters, date_begin_end: dateret }
                });
                setDatasetDashboardAnalytical({
                  ...datasetDashboardAnalytical,
                  filters: { ...datasetDashboardAnalytical.filters, date_begin_end: dateret }
                });

                setStartDate(start);
                let newMaxDate = calcMaxDate(start, end);
                newMaxDate = moment(newMaxDate).subtract(1, 'days').toDate();
                setMaxDate(newMaxDate);
                setEndDate(newMaxDate > end ? end : newMaxDate);
              }}
              maxDate={maxDate}
              className={'form-control mr-3'}
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              dateFormat={formatoData}
              isClearable={true}
              locale={idiom.replaceAll('-', '').trim()}
              disabled={!!codeEquipment}  // Desabilitar se codeEquipment não estiver vazio
            />  
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.branch_id.length > 0 ? dataset?.filters?.branch_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ 
                      ...dataset, 
                      filters: { ...dataset.filters, branch_id: [Number(e.target.value)] } 
                    });
                    setDatasetDashboardAnalytical({ 
                      ...datasetDashboardAnalytical, 
                      filters: { ...datasetDashboardAnalytical.filters, branch_id: [Number(e.target.value)] } 
                    });
                    setCodeEquipment('');  // Limpar o campo de equipamento
                  }}
                  disabled={!!codeEquipment}  // Desabilitar se o equipamento estiver selecionado
                >
                  <option>{t("FILTER.SELECT")}</option>
                  {_.map(branches, (item) => (
                    <option key={item.id} value={item.id}>{item.fullName}</option>
                  ))}
                </Form.Control>
                <label>{t("FILTER.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='code_equipment'
                  id='code_equipment'
                  type='text'
                  placeholder={t(`EQUIPMENT.CODE_EQUIPMENT`)}
                  className='form-control'
                  value={codeEquipment}
                  onChange={(e) => {
                    setCodeEquipment(e.target.value.trim());

                    if (e.target.value.trim() !== '') {
                      setDataset({ 
                        ...dataset, 
                        filters: { 
                          ...dataset.filters, 
                          code_equipment: [e.target.value.trim()], 

                        }
                      });
                      setDatasetDashboardAnalytical({ 
                        ...datasetDashboardAnalytical, 
                        filters: { 
                          ...datasetDashboardAnalytical.filters, 
                          code_equipment: [e.target.value.trim()],

                        } 
                      });
                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, code_equipment: [] } });
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, code_equipment: [] } });
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch(e);
                    }
                  }}
                  disabled={!!dataset.filters.branch_id.length}  // Desabilitar se branch_id estiver selecionado
                />
                <label>{t("FILTER.EQUIPMENT")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
        </Row>

        
        <Row className='mt-3'>
          <Col xs="auto">
            <ButtonSearch onClick={(e) => handleSearch(e)} isLoading={isLoading} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => handleClean()} isLoading={isLoading}/>
          </Col>

          <Col xs="auto">
            <ButtonExport onClick={() => exportFile()} isLoading={isLoading}/>
          </Col>
        </Row> 
      </Form>
      {/* Exibindo a quantidade total de registros */}
    <Row className="mt-3">
      <Col>
      
        <div className="text-end">
          <strong>{t("DASHBOARD.TOTAL")}{data[0]?.total_record_count} {t("DASHBOARD.TOTAL_RECORDS")}</strong>
        </div>
      </Col>
    </Row>

    <Row className="align-items-center pb-3">
      <Col sm={12}>          
        <Table
          data={data}
          columns={columns}
          update={null}
          total_records={21}
          msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} 
        />
      </Col>
    </Row>
    </>
  );
};

export default PickuedUpEquipment;
